import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('@/components/Layout'),
        redirect: 'index',
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import('@/views/index'),
                meta: { activeTag: 'index' }
            },
            {
                path: 'noticeList',
                name: 'noticeList',
                component: () => import(/* webpackChunkName: "about" */ '@/views/index/NoticeList'),
                meta: { activeTag: 'index' }
            },
            {
                path: 'noticeDetail',
                name: 'noticeDetail',
                component: () => import(/* webpackChunkName: "about" */ '@/views/index/NoticeDetail'),
                meta: { activeTag: 'index' }
            },
            {
                path: 'bidNotice',
                name: 'bidNotice',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/bid'),
                meta: { activeTag: 'bidNotice' }
            },
            {
                path: 'bidNoticeDetail',
                name: 'bidNoticeDetail',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/bid/detail'),
                meta: { activeTag: 'bidNotice' }
            },
            {
                path: 'noBidNotice',
                name: 'noBidNotice',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/noBid'),
                meta: { activeTag: 'noBidNotice' }
            },
            {
                path: 'noBidNoticeDetail',
                name: 'noBidNoticeDetail',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/noBid/detail'),
                meta: { activeTag: 'noBidNotice' }
            },
            {
                path: 'candidateNotice',
                name: 'candidateNotice',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/candidate'),
                meta: { activeTag: 'candidateNotice' }
            },
            {
                path: 'candidateNoticeDetail',
                name: 'candidateNoticeDetail',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/candidate/detail'),
                meta: { activeTag: 'candidateNotice' }
            },
            {
                path: 'winNotice',
                name: 'winNotice',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/win'),
                meta: { activeTag: 'winNotice' }
            },
            {
                path: 'winNoticeDetail',
                name: 'winNoticeDetail',
                component: () => import(/* webpackChunkName: "about" */ '@/views/notice/win/detail'),
                meta: { activeTag: 'winNotice' }
            },
            {
                path: 'about',
                name: 'about',
                component: () => import(/* webpackChunkName: "about" */ '@/views/about'),
                meta: { activeTag: 'about' }
            },
            {
                path: 'supplier',
                name: 'supplier',
                component: () => import(/* webpackChunkName: "about" */ '@/views/supplier'),
                meta: { activeTag: 'supplier' },
                children: [
                    {
                        path: 'bidProject',
                        name: 'bidProject',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/bidProject'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/bidProject', menuName: "招标项目" }
                    },
                    {
                        path: 'bidProjectDetail',
                        name: 'bidProjectDetail',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/bidProject/detail'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/bidProject', menuName: "招标项目详情", parentMenu: { menuName: "招标项目", menuPath: "/bidProject" } }
                    },
                    {
                        path: 'noBidProject',
                        name: 'noBidProject',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/noBidProject'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/noBidProject', menuName: "非招标项目" }
                    },
                    {
                        path: 'quotation',
                        name: 'quotation',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/noBidProject/quotation'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/noBidProject', menuName: "报价", parentMenu: { menuName: "非招标项目", menuPath: "/noBidProject" } }
                    },
                    {
                        path: 'noBidProjectDetail',
                        name: 'noBidProjectDetail',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/noBidProject/detail'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/noBidProject', menuName: "成交结果", parentMenu: { menuName: "非招标项目", menuPath: "/noBidProject" } }
                    },
                    {
                        path: 'myContract',
                        name: 'myContract',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/myContract'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/myContract', menuName: "我的合同" }
                    },
                    {
                        path: 'basicInfo',
                        name: 'basicInfo',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/basicInfo'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/basicInfo', menuName: "基本资料" }
                    },
                    {
                        path: 'updatePassword',
                        name: 'updatePassword',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/updatePassword'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/updatePassword', menuName: "修改密码" }
                    },
                    {
                        path: 'certification',
                        name: 'certification',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/supplier/certification'),
                        meta: { activeTag: 'supplier', activeMenu: '/supplier/certification', menuName: "学习认证" }
                    },
                ]
            }
        ]
    },
    {
        path: '/regist',
        name: 'regist',
        component: () => import(/* webpackChunkName: "about" */ '../views/regist.vue')
    },
]

const router = new VueRouter({
    routes,
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    base: 'vendor'
})

export default router
